import {
  Avatar,
  Card,
  CardContent,
  Grid,
  Typography
} from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Storage as StorageIcon } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  root: { height: '100%' },
  content: {
    alignItems: 'center',
    display: 'flex'
  },
  title: { fontWeight: 700 },
  avatar: {
    backgroundColor: theme.palette.primary.main,
    height: 56,
    width: 56
  },
  icon: {
    height: 32,
    width: 32
  },
  difference: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  differenceIcon: { color: theme.palette.success.dark },
  differenceValue: {
    color: theme.palette.success.dark,
    marginRight: theme.spacing(1)
  }
}));

const TotalNaoConformidadeBD = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  return (
    <Card
      {...rest}
      className={clsx(
        classes.root,
        className
      )}
    >
      <CardContent>
        <Grid
          container
          justifyContent="space-between"
        >
          <Grid item>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="body2"
            >
              NÃO CONFORMIDADE BANCOS DADOS
            </Typography>

            <Typography variant="h3">
              {rest.totalDiagnosticoBD}
            </Typography>
          </Grid>

          <Grid item>
            <Avatar className={classes.avatar}>
              <StorageIcon
                className={classes.icon}
              />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

TotalNaoConformidadeBD.propTypes = {
  className: PropTypes.string
};

export default TotalNaoConformidadeBD;